import type { ReactNode } from "react";

import { Spacer } from "@aviary/components";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import { Container } from "../Container";

import * as styles from "./PageWrapper.styles";

interface Props {
  children?: ReactNode;
  hasNoTopSpacer?: boolean;
  withSidebar?: boolean;
}

/**
 * Documentation:
 * https://aviary.docs.fullscript.cloud/components/layouts/components/PageWrapper
 */
const PageWrapper = ({ withSidebar, children, hasNoTopSpacer = false }: Props) => {
  const { desktop } = useBreakpoints();
  const isDesktopAndLarger = desktop.greaterThan;

  return (
    <main tabIndex={0} css={styles.pageWrapper} id="main-content">
      {!hasNoTopSpacer && (
        <Spacer
          type={isDesktopAndLarger ? "page" : "section"}
          data-testid={isDesktopAndLarger ? "page-spacer" : "section-spacer"}
        />
      )}
      <Container withSidebar={withSidebar}>{children}</Container>
    </main>
  );
};

export { PageWrapper };
